<template>
  <div>
    <Row class="main-home-tabs" :getter="10" type="flex">
      <Col style="flex-grow: 1;flex-shrink: 1;width: 95%">
        <Tabs
          capture-focus
          type="card"
          :value="nav_route"
          :closable="Getnavlist.length != 1"
          @on-click="gopath"
          @on-tab-remove="removeTab"
        >
          <TabPane
            ref="tabPanes"
            v-for="(tab, i) in Getnavlist"
            :key="tab.title"
            :name="tab.to"
            :label="tab.title"
          />
        </Tabs>
      </Col>
      <Col style="flex-grow: 0;flex-shrink: 0;">
        <Dropdown
          content="content"
          placement="bottom-end"
          @on-click="event => removeNavList({ state: event, value: nav_route })"
        >
          <div class="i-layout-tabs-close-main">
            <Icon type="ios-settings" size="18" />
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="left">
              <Icon type="md-arrow-round-back" />关闭左边
            </DropdownItem>
            <DropdownItem name="right">
              <Icon type="md-arrow-round-forward" />关闭右边
            </DropdownItem>
            <DropdownItem name="other">
              <Icon type="md-close-circle" />关闭其他
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  inject: ['reload'],
  data () {
    return {
      scrollTop: 0
    };
  },
  computed: {
    ...mapGetters(["Getnavlist", 'remove']),
    nav_route () {
      const routedata = this.$route.matched[1]
      if (routedata.meta.Submenu) {
        const routedata2 = this.$route.matched[2]
        return routedata2.name
      } else {
        return routedata.name
      }
    }
  },
  methods: {
    ...mapActions(["removeNavList"]),
    shadowfun (event) {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    gopath (value, key) {
      const liveshow = this.$route.name == 'scode' && value == 'liveshow' && value == 'liveshowAll'
      if (liveshow) {
        this.reload()
      } else {
        if (this.$route.name !== value) {
          this.$router.push({ name: value });
        } else {
          this.reload()
        }
      }
    },
    removeTab (value) {
      this.removeNavList({ state: 'one', value: value });
      const active = this.$refs.tabPanes[0].$parent.activeKey
      if (value != active && active != this.$route.name) {
        this.$router.push({ name: active });
      }
    }
  }
};
</script>


<style lang="scss">
.main-home-tabs {
  margin: 5px 20px;
  background: transparent;
  user-select: none;
  position: relative;
  &.main-home-tabs-scrolltop-shadow {
    box-shadow: 2px 2px 3px -20px rgba(0, 0, 0, 0.2),
      0px 4px 3px -4px rgba(0, 0, 0, 0.14), 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
  }
  .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    height: 32px;
    padding-bottom: 5px;
    background: #fff;
    border: solid 1px #babbbd;
    color: #babbbd;
    border-radius: 4px;
    margin-right: 8px;
  }
  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
    // color: #363e4f;
    border: solid 1px $main-home-tabs-card-active-borderColor;
    background: $main-home-tabs-card-active-bg;
    color: $main-home-tabs-card-active-color;
    .ivu-tabs-close {
      color: $main-home-tabs-card-active-color;
    }
  }
  .ivu-tabs-nav-next,
  .ivu-tabs-nav-prev {
    width: 32px;
    text-align: center;
  }
  .ivu-tabs-nav-container {
    font-size: 15px;
  }
  .ivu-tabs-nav-scrollable {
    padding: 0 32px;
  }
  .i-layout-tabs-close-main {
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: #fff;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>
